<template>
    <div class="popup-wrap" v-if="popup.show">
        <div class="overlay" v-if="popup.show" :style="`opacity: ${overlayOpacity}; z-index: ${popup.topography};`" @click="$emit('close')"></div>
        <div class="popup popup-simple" :style="`z-index: ${popup.topography};`">
            <div class="flex heading">
                <h1>{{ popup.title }}</h1>
                <img class="btn flex-right" src="@/assets/Images/Close.png" alt="Close" title="Close" width="40" height="40" @click="$emit('close')"/>
            </div>
            <div class="content">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PopupSimple",
    props: {
        popup: Object,
        showOverlay: Boolean
    },
    data: () => ({ overlayOpacity: 0 }),
    beforeMount: function() { this.overlayOpacity = this.showOverlay ? .5 : 0; },
    emits: [ "close" ]
};
</script>